import { type PropsWithChildren, useEffect, useMemo } from 'react';
import { ThemeContext } from './ThemeContext';
import type { CustomThemeConfig, CustomThemeConfigOverride } from './types';
import { mergeCustomThemeConfig, setCssVariables } from './utils';

type P = PropsWithChildren<{
  defaultTheme: CustomThemeConfig;
  overrideTheme?: CustomThemeConfigOverride;
}>;

const ThemeProvider = ({ children, defaultTheme, overrideTheme }: P) => {
  const theme = useMemo(
    (): CustomThemeConfig => mergeCustomThemeConfig({ defaultTheme, overrideTheme }),
    [defaultTheme, overrideTheme],
  );

  useEffect(() => {
    setCssVariables({ object: theme });
  }, [theme]);

  return <ThemeContext.Provider value={theme}>{children}</ThemeContext.Provider>;
};

export default ThemeProvider;
